import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'ingsv-adm-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Input() inputType = '';
  @Output() inputChanged = new EventEmitter<any>();

  inputForm: FormGroup;

  constructor(
    fb: FormBuilder
  ) {
    this.inputForm = fb.group({
      input: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.inputForm
      .valueChanges
      .subscribe(form => {
        this.inputChanged.emit(form.input);
      });
  }
}
